/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Student_RecordingInputs */

const en_student_recording = /** @type {(inputs: Student_RecordingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recording...`)
};

const he_student_recording = /** @type {(inputs: Student_RecordingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`רושם...`)
};

/**
* | output |
* | --- |
* | "Recording..." |
*
* @param {Student_RecordingInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const student_recording = /** @type {((inputs?: Student_RecordingInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Student_RecordingInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_student_recording(inputs)
	return he_student_recording(inputs)
});